module.exports = __webpack_public_path__ + "img/1f638.be1c936.svg";